import React, { Component } from 'react';
// import { Route, Redirect, Switch, withRouter } from 'react-router-dom';
import { Route, Switch, withRouter } from 'react-router-dom';
import { loadReCaptcha } from 'react-recaptcha-v3';

import Sniffr from 'sniffr';

import CONSTANTS from './utils/Constants';

import CategorizeShare from "./containers/CategorizeShare";
import ShareSomething from "./containers/ShareSomething";
import Thanks from "./containers/Thanks";
import NoMatch from "./containers/NoMatch";
import ReactGa from './utils/GoogleAnalyticsSetup';

class App extends Component {
	constructor(props) {
		super(props);

		this.state = {
			locationKey: null,
			origin: null,
			sourceType: props.sourceType,
			isMobile: this.isMobile()
		}

		// Individual GA settings
		// ReactGa.setup({
		// 	'name': CONSTANTS.GA.TRACKER_NAME,
		// 	'cookieDomain': CONSTANTS.GA.COOKIE_DOMAIN,
		// 	'anonymizeIp': true,
		// 	'forceSsl': true,
		// 	'dataSource': 'extension'
		// });
	}

	componentDidMount() {
		// TODO - move recaptcha id out of here
		loadReCaptcha(process.env.REACT_APP_RECAPTCHA_ID);
		window.addEventListener("message", this.handleWidgetMsg);
	}

	componentWillUnmount() {
		window.removeEventListener("message", this.handleWidgetMsg);
	}

	isMobile = () => {
		let browserInfo = new Sniffr();
		browserInfo.sniff(window.navigator.userAgent);

		// Still iterating
		let suggestsMobile = browserInfo.device.name !== 'Unknown' || browserInfo.os.name == "android";
		console.info(`isMobile: ${suggestsMobile}`);
		console.info(browserInfo);
		return suggestsMobile;
	}

	handleWidgetMsg = e => {
		const {type, locationKey, locationContact, embeddedOn} = e.data;

		if(type && type === 'LOCATION_INFO') {
			this.setState({
				locationKey,
				locationContact,
				messageSource: e.source,
				embeddedOn
			});
		}
	}
	
	render() {
		return (
			<Switch>
				<Route
					exact
					path="/"
					render={props =>
						<CategorizeShare {...props}
							isMobile={this.state.isMobile}
							messageSource={this.state.messageSource}
							locationContact={this.state.locationContact} />
					}
				/>

				<Route
					path="/tip"
					render={props =>
						<ShareSomething isTip {...props}
							sourceType={this.state.sourceType}
							embeddedOn={this.state.embeddedOn}
							messageSource={this.state.messageSource}
							locationKey={this.state.locationKey} />
					}
				/>

				<Route
					path="/share/:category"
					render={props =>
						<ShareSomething {...props}
							embeddedOn={this.state.embeddedOn}
							sourceType={this.state.sourceType}
							locationKey={this.state.locationKey} />
					}
				/>

				<Route
					path="/thanks/:category?"
					render={props =>
						<Thanks {...props}
							isMobile={this.state.isMobile}
							messageSource={this.state.messageSource}
							locationContact={this.state.locationContact} />
					}
				/>

				{/* No match - 404 */}
				<Route
					render={props =>
						<NoMatch {...props}	/>}
				/>
			</Switch>
		);
	}
}

export default withRouter(App);
